module.exports = __webpack_public_path__ + "themify.cba68f986e60df8c74f4.svg";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/node_modules/ti-icons/fonts/themify.svg
// module id = ../../../../ti-icons/fonts/themify.svg
// module chunks = styles